import { FC, Fragment } from "react";
import { useAppSelector } from "@/store/hooks";
import { gridResourcesCleanProcessesSelector } from "@/store/resources-grid/selectors/clean/gridResourcesCleanProcessesSelector";
import { ResourceGridCleanDialog } from "@/components/pages/common/resources-ag-grid/components/resource-clean/clean-dialog/ResourceGridCleanDialog";
import { ResourceGridCleanProcess } from "@/components/pages/common/resources-ag-grid/components/resource-clean/ResourceGridCleanProcess";

export const ResourceGridCleanComponents: FC = () => {
  const cleanProcesses = useAppSelector(gridResourcesCleanProcessesSelector);

  return (
    <Fragment>
      {cleanProcesses.map((process) => {
        return (
          <ResourceGridCleanProcess key={process.executionId} {...process} />
        );
      })}

      <ResourceGridCleanDialog />
    </Fragment>
  );
};
